import React from "react"
import { Link, graphql } from "gatsby"
import { Link as LinkScroll, animateScroll as scroll } from "react-scroll";
import Img from "gatsby-image"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Form from "../components/contactform"
import BG from "../components/background"

import "../styles/global.css"


const IndexPage = ({ data }) => {
  const posts = data.allWpPost.edges
  return (
    <Layout>
      <SEO 
        title="WCL"
        description="descriptionです"
      />
      <div className="top">
        <div className="hero">
          <h1>
            <span>WEB</span>
            <span className="yellow">COMMUNICATION</span>
            <span>LAB</span>  
          </h1>
          <p>
          あなたのブランド・事業・商品を<br />
          コンテンツとデジタルソリューションで<br />
          お手伝いいたします。
          </p>
          <div className="anker__link">
            <h2>SERVICE</h2>
            <ul> 
              <li><LinkScroll
                  to="service01"
                  spy={true}
                  smooth={true}
                  offset={0}
                  duration={500}
                >
                WEB
              </LinkScroll>
              </li>
              <li>
                <LinkScroll
                  to="service02"
                  spy={true}
                  smooth={true}
                  offset={0}
                  duration={500}
                >
                EC
              </LinkScroll>
              </li>
              <li>
                <LinkScroll
                  to="service03"
                  spy={true}
                  smooth={true}
                  offset={0}
                  duration={500}
                >
                DX
              </LinkScroll></li>
            </ul>
          </div>
        </div>
  
        <div id="service01" className="service section">
          <h2>WEB
            <span>ホームページ制作</span>
          </h2>
          <p>
          HTMLやJavaScriptなどお客様のご要望に合った制作方法で作成いたします。 お客様で更新可能したい場合はWordPress、ランディングページ（LP）などはHTMLやJavaScriptなどを使用します。 デザインテンプレートなどを利用することで、費用をなるべく抑えて制作することも可能ですので、お気軽にご相談ください。
          </p>
          <Link
            to="/service#service01"
            className="btn"
          >
            詳しく見る
          </Link>
        </div>
  
        <div id="service02" className="service section">
          <h2>EC
            <span>オンラインショップ制作</span>
          </h2>
          <p>
          ウェブサイト、ホームページ制作のみならず、オンラインショップが一般的になってきています。<br />
          BASEやStoresなどのインスタントカートの導入や、目新しいShopifyなどの導入補助からASP系のECシステムの構築まで、ワンストップでお手伝いさせていただきます。
          </p>
          <Link
            to="/service#service02"
            className="btn"
          >
            詳しく見る
          </Link>
        </div>
  
        <div id="service03" className="service section">
          <h2>DX
            <span>デジタルトランスフォーメーション施策</span>
          </h2>
          <p>
          これってデジタル化できないかな。ちょっとしたことを便利にしたい。新しい技術を導入したい。<br />
          日常のちょっとしたことで、そんな場面ありませんか？<br />
          私たちがそのお手伝いをさせていただきます。あなたの身近なこと、あなたのお仕事の新しい展開を一緒に考えていきましょう。
          </p>
          <Link
            to="/service#service03"
            className="btn"
          >
            詳しく見る
          </Link>
        </div>
  
        <div id="news" className="newslist section _none">
          <h2>News</h2>
          {posts.map(({ node }) => (
            <div key={node.slug} className="flex">
              <div className="date">{node.date}</div>
              <h3>
                <Link to={node.slug}>{node.title}</Link>
              </h3>
              {/* <Img
                fixed={node.featuredImage.node.localFile.childImageSharp.fixed}
                alt={node.title}
              /> */}
            </div>
          ))}
          <Link to="news" className="readmore">
            もっと見る
          </Link>
        </div>
        
        <div id="contact" className="contact section">
          <h2>Contact</h2>
          <Form />
        </div>
        
      </div>
      <BG />

    </Layout>
  )
}

export default IndexPage

export const pageQuery = graphql`
  query HomeQuery {
    allWpPost(sort: { fields: [date], order: DESC }) {
      edges {
        node {
          date(formatString: "YYYY/MM/DD")
          slug
          title
          featuredImage {
            node {
              localFile {
                childImageSharp {
                  fixed(width: 500, height: 500) {
                    ...GatsbyImageSharpFixed
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`